import { render, staticRenderFns } from "./LegalPageLayout.vue?vue&type=template&id=9c5543c6&scoped=true"
import script from "./LegalPageLayout.vue?vue&type=script&lang=js"
export * from "./LegalPageLayout.vue?vue&type=script&lang=js"
import style0 from "./LegalPageLayout.vue?vue&type=style&index=0&id=9c5543c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5543c6",
  null
  
)

export default component.exports